import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import Chores from 'components/pages/parents/chores/Chores'
import Dashboard from 'components/pages/parents/Dashboard'
import Header from 'components/pages/parents/partials/Header'
import Kids from 'components/pages/parents/kids/Kids'
import Rewards from 'components/pages/parents/Rewards'
import Settings from 'components/pages/parents/Settings'
import Section from 'components/ui/Section'

const ParentRouter = () => {
  return (
    <>
      <Header />
      <Section className="relative">
        <Route path="/parents" exact>
          <Redirect to="/parents/kids" />
        </Route>
        <Route path="/parents/dashboard" exact>
          <Dashboard />
        </Route>
        <Route path="/parents/kids" exact>
          <Kids />
        </Route>
        <Route path="/parents/chores" exact>
          <Chores />
        </Route>
        <Route path="/parents/rewards" exact>
          <Rewards />
        </Route>
        <Route path="/parents/settings" exact>
          <Settings />
        </Route>
      </Section>
    </>
  )
}

export default ParentRouter
